import { CSSProperties } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Colors } from '../../common/Colors';
import { BoxEmotion } from '../../common/Box/styles';

export const valueStyle = {
  overflow: 'hidden',
  maxWidth: 'none',
  marginLeft: 0,
  marginRight: 0,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};

export const getCustomStyles: any = () => ({
  control: (provided: CSSProperties, state: any) => ({
    ...provided,
    overflow: 'hidden',
    flexWrap: 'nowrap',
    alignItems: 'center',
    height: '4rem',
    minHeight: 'auto',
    lineHeight: 1.2,
    fontSize: '1.4rem',
    backgroundColor: state.isFocused ? Colors.ut.inputDown : Colors.ut.input,
    borderRadius: '0.8rem',
    borderWidth: 0,
    boxShadow: 'none',
    transition: 'background-color 0.25s, color 0.25s',

    '&:hover': {
      backgroundColor: state.isFocused ? Colors.ut.inputDown : Colors.ut.inputUp
    }
  }),

  input: () => ({
    position: 'absolute',

    input: {
      lineHeight: 'inherit'
    }
  }),

  valueContainer: () => ({
    ...valueStyle,
    position: 'relative',
    flexGrow: 1,
    padding: '0 0.5rem 0 2rem',

    '&:after': {
      content: '" "',
      display: 'inline',
      whiteSpace: 'pre'
    }
  }),

  singleValue: (provided: CSSProperties) => ({
    ...provided,
    maxWidth: 'calc(100% - 2.5rem)',
    margin: 0,
    color: Colors.black
  }),

  placeholder: (provided: CSSProperties) => ({
    ...provided,
    margin: 0,
    color: Colors.rgbaBlack30
  }),

  menu: (provided: CSSProperties) => ({
    ...provided,
    zIndex: 500,
    top: '100%',
    margin: 0,
    backgroundColor: Colors.white,
    borderRadius: '0.2rem',
    boxShadow: `0 0 0 1px ${Colors.rgbaBlack5}, 0 0.7rem 1rem ${Colors.rgbaBlack10}`
  }),

  menuList: (provided: CSSProperties) => ({
    ...provided,
    padding: 0
  }),

  option: (provided: CSSProperties, state: any) => ({
    cursor: 'default',
    display: 'flex',
    alignItems: 'center',
    padding: '1.1rem 2rem',
    fontSize: '1.4rem',
    lineHeight: 1.2,
    textAlign: 'left',
    color: state.isSelected && Colors.black,
    backgroundColor:
      (state.isSelected && Colors.rgbaBlueLight55) || (state.isFocused && Colors.rgbaBlack5),
    transition: `background-color ${state.isFocused ? '0.1s ease-out' : '0.3s ease-in'}`,

    '&:focus': {
      outline: 0
    },

    '&:active': {
      backgroundColor: Colors.rgbaBlack10
    }
  }),

  noOptionsMessage: (provided: CSSProperties) => ({
    ...provided,
    color: Colors.rgbaBlack50
  }),

  multiValue: () => ({
    display: 'inline',

    '&:not(:last-of-type):after': {
      content: '", "',
      display: 'inline'
    }
  }),

  multiValueLabel: () => ({
    display: 'inline'
  }),

  indicatorsContainer: (provided: CSSProperties) => ({
    ...provided,
    position: 'relative',
    flexShrink: 0
  })
});

export const clearButton = css`
  & + ${BoxEmotion} {
    display: none;
  }
`;

export const Icon = styled('img')`
  flex-shrink: 0;
  width: 1.6rem;
  height: auto;
  margin-right: 1.1rem;
`;
